import type { Movie, NewsItem } from '@/types/movie';

export const movies: Movie[] = [
  {
    id: 'xinghai-yuanzheng',
    title: '星海远征',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%2C%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20planet%2C%20deep%20space%20nebula%20backdrop%2C%20dramatic%20rim%20lighting%2C%20epic%20scale%2C%20minimalist%20composition%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=sm-cover-01&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20space%20scene%20with%20a%20vast%20glowing%20blue%20planet%20and%20drifting%20spacecraft%2C%20deep%20starfield%20nebula%2C%20cool%20tones%20with%20warm%20accent%20light%2C%20atmospheric%20scale%2C%20no%20text&width=1600&height=900&seq=sm-back-01&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '冒险', '剧情'],
    rating: 8.7,
    duration: '148分钟',
    director: '陆川',
    actors: ['吴京', '张译', '李雪健'],
    synopsis: '在一个资源濒临枯竭的未来地球，一支由各国顶尖宇航员组成的远征队踏上寻找新家园的旅途。当飞船驶入未知星域，他们必须在信念与生存之间做出抉择，而身后是数十亿等待消息的人类。',
    releaseDate: '2024-07-19',
    views: 9820000,
    favorites: 152000,
    reviews: [
      { author: '银河观察者', rating: 9.0, content: '视听语言极其震撼，尤其是星海穿越那一段，把孤独感与壮阔感同时推到极致。' },
      { author: '影迷小林', rating: 8.5, content: '硬核设定之下依然有温度，人物动机可信，是近年国产科幻的一次扎实升级。' },
    ],
    featured: true,
    updatedAt: '2024-09-12',
  },
  {
    id: 'changye-jiangming',
    title: '长夜将明',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20drama%20poster%20of%20a%20rainy%20city%20street%20at%20night%2C%20a%20silhouetted%20detective%20under%20a%20streetlamp%2C%20moody%20navy%20and%20amber%20tones%2C%20moody%20cinematic%20lighting%2C%20rain%20reflections%2C%20no%20text&width=400&height=600&seq=sm-cover-02&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Atmospheric%20rainy%20urban%20night%20scene%20with%20neon%20reflections%20on%20wet%20pavement%2C%20a%20figure%20walking%20away%20into%20fog%2C%20deep%20blue%20with%20warm%20orange%20highlights%2C%20cinematic%20mystery%20mood%2C%20no%20text&width=1600&height=900&seq=sm-back-02&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 9.1,
    duration: '全24集',
    director: '张黎',
    actors: ['张译', '王凯', '倪妮'],
    synopsis: '一桩尘封十二年的旧案重新浮出水面，让已经离开警队的老刑警重新卷入漩涡。随着调查层层深入，长夜之下每个人都藏着自己的秘密，而真相往往比想象更加残酷。',
    releaseDate: '2024-05-08',
    views: 15600000,
    favorites: 268000,
    reviews: [
      { author: '追剧星球', rating: 9.5, content: '节奏控制得极好，每一集结尾都让人忍不住点开下一集，人物弧光完整。' },
      { author: '夜行笔记', rating: 8.8, content: '不靠血腥和音效吓人，靠的是人物关系的千丝万缕，这才是高级悬疑。' },
    ],
    featured: true,
    updatedAt: '2024-09-18',
  },
  {
    id: 'fengqi-changan',
    title: '风起长安',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20ancient%20palace%20with%20red%20lanterns%20and%20golden%20roof%20tiles%2C%20a%20scholar%20in%20flowing%20robes%2C%20rich%20vermilion%20and%20gold%20palette%2C%20elegant%20painterly%20style%2C%20no%20text&width=400&height=600&seq=sm-cover-03&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['古装', '历史', '权谋'],
    rating: 8.5,
    duration: '全40集',
    director: '李雪',
    actors: ['胡歌', '陈道明', '刘涛'],
    synopsis: '盛唐将倾，朝堂暗流涌动。一位出身寒门的年轻官员被卷入权力漩涡，他既要守住心中的道，又要在波谲云诡的争斗中活下去，见证一个时代的辉煌与落幕。',
    releaseDate: '2023-11-02',
    views: 12300000,
    favorites: 201000,
    reviews: [
      { author: '长安旧梦', rating: 8.6, content: '服化道水准极高，台词有古韵又不拗口，是近年难得的正剧气质。' },
      { author: '历史课代表', rating: 8.2, content: '权谋线环环相扣，群像塑造令人印象深刻。' },
    ],
    updatedAt: '2024-08-30',
  },
  {
    id: 'niguang-zhuixiong',
    title: '逆光追凶',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Gritty%20crime%20thriller%20movie%20poster%2C%20a%20man%20silhouetted%20against%20harsh%20backlight%20in%20a%20narrow%20alley%2C%20high%20contrast%20shadows%2C%20cool%20blue%20with%20orange%20streetlight%2C%20tense%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-04&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Neo-noir%20city%20alley%20at%20dusk%20with%20long%20shadows%20and%20a%20single%20backlit%20figure%2C%20colder%20blue%20tones%20with%20warm%20rim%20light%2C%20suspenseful%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=sm-back-04&orientation=landscape',
    year: 2024,
    region: '中国香港',
    genres: ['犯罪', '悬疑', '动作'],
    rating: 8.2,
    duration: '132分钟',
    director: '庄文强',
    actors: ['梁朝伟', '刘德华', '周迅'],
    synopsis: '一名被判冤狱的老警察出狱后，决定用自己的方式追查当年陷害他的真凶。逆光而行，他要面对的不只是敌人，还有那个已经不再相信他的世界。',
    releaseDate: '2024-03-15',
    views: 7640000,
    favorites: 118000,
    reviews: [
      { author: '港片情怀', rating: 8.4, content: '双雄对决的张力十足，老戏骨对戏看得过瘾。' },
      { author: '阿飞', rating: 8.0, content: '氛围营造很到位，结尾的留白处理得高级。' },
    ],
    featured: true,
    updatedAt: '2024-09-05',
  },
  {
    id: 'wenrou-xianjing',
    title: '温柔的陷阱',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%2C%20an%20elegant%20woman%20in%20a%20soft%20lit%20rainy%20window%2C%20muted%20warm%20beige%20and%20dusty%20rose%20tones%2C%20delicate%20cinematic%20lighting%2C%20melancholic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-05&orientation=portrait',
    year: 2023,
    region: '韩国',
    genres: ['爱情', '剧情', '悬疑'],
    rating: 7.9,
    duration: '121分钟',
    director: '朴赞郁',
    actors: ['孙艺珍', '李到晛'],
    synopsis: '一场看似完美的婚姻背后，藏着精心编织的谎言。当女主角逐渐察觉身边的温柔其实是一张网时，她必须在真相与自我保护之间做出选择。',
    releaseDate: '2023-09-22',
    views: 5230000,
    favorites: 86000,
    reviews: [
      { author: '首尔影评', rating: 8.0, content: '感情戏克制而精准，反转来得不突兀。' },
      { author: '阿珍', rating: 7.8, content: '两位主演的化学反应很棒，氛围感十足。' },
    ],
    updatedAt: '2024-07-21',
  },
  {
    id: 'shenhai-huisheng',
    title: '深海回声',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Underwater%20sci-fi%20thriller%20poster%2C%20a%20deep%20sea%20research%20submersible%20lit%20by%20a%20single%20beam%2C%20bioluminescent%20creatures%20in%20the%20dark%20abyss%2C%20teal%20and%20cyan%20glow%2C%20isolated%20tense%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-06&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20abyss%20with%20glowing%20bioluminescent%20jellyfish%20and%20a%20distant%20submersible%20light%20beam%2C%20dark%20teal%20water%2C%20eerie%20cinematic%20atmosphere%2C%20volumetric%20light%2C%20no%20text&width=1600&height=900&seq=sm-back-06&orientation=landscape',
    year: 2024,
    region: '美国',
    genres: ['科幻', '惊悚'],
    rating: 8.4,
    duration: '126分钟',
    director: '丹尼斯·维伦纽瓦',
    actors: ['马修·麦康纳', '艾米莉·布朗特'],
    synopsis: '一支深海探测队在万米海沟捕捉到一段来历不明的信号。随着他们下潜得越来越深，队员们开始怀疑，那个声音并非来自自然，而是某种正在等待他们的存在。',
    releaseDate: '2024-06-28',
    views: 8910000,
    favorites: 143000,
    reviews: [
      { author: '深海恐惧症', rating: 8.6, content: '压抑感从头贯穿到尾，深海的未知被诠释得淋漓尽致。' },
      { author: 'IMAX党', rating: 8.2, content: '音效设计一流，必须在影院看。' },
    ],
    featured: true,
    updatedAt: '2024-09-14',
  },
  {
    id: 'chunri-wuyu',
    title: '春日物语',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20film%20poster%2C%20a%20girl%20and%20a%20small%20cat%20on%20a%20hilltop%20under%20blooming%20cherry%20trees%2C%20soft%20pastel%20spring%20colors%2C%20warm%20gentle%20sunlight%2C%20hand%20painted%20illustration%20style%2C%20no%20text&width=400&height=600&seq=sm-cover-07&orientation=portrait',
    year: 2022,
    region: '日本',
    genres: ['动画', '治愈', '家庭'],
    rating: 9.0,
    duration: '108分钟',
    director: '新海诚',
    actors: ['花泽香菜', '神木隆之介'],
    synopsis: '一个关于告别与成长的故事。失去母亲的小女孩在乡下的春天里遇见了会说话的猫，它带着她重新认识家、记忆与那些被忽略的温柔时光。',
    releaseDate: '2022-04-15',
    views: 6740000,
    favorites: 189000,
    reviews: [
      { author: '二次元小站', rating: 9.3, content: '画面美到窒息，情感表达细腻，看哭了。' },
      { author: '春天的风', rating: 8.8, content: '每帧都是壁纸，音乐和画面配合得恰到好处。' },
    ],
    updatedAt: '2024-06-02',
  },
  {
    id: 'bianjing-xian',
    title: '边境线',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=War%20drama%20series%20poster%2C%20soldiers%20in%20winter%20snow%20on%20a%20mountain%20pass%2C%20desaturated%20cold%20palette%20with%20a%20warm%20signal%20flare%2C%20gritty%20realistic%20texture%2C%20heroic%20somber%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-08&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Vast%20snow%20covered%20mountain%20borderland%20at%20dawn%20with%20distant%20figures%20and%20smoke%2C%20cold%20slate%20and%20white%20palette%2C%20warm%20orange%20horizon%20glow%2C%20epic%20somber%20cinematic%20tone%2C%20no%20text&width=1600&height=900&seq=sm-back-08&orientation=landscape',
    year: 2024,
    region: '中国大陆',
    genres: ['战争', '剧情', '历史'],
    rating: 8.8,
    duration: '全32集',
    director: '康洪雷',
    actors: ['张译', '段奕宏', '朱亚文'],
    synopsis: '在海拔四千米的边关哨所，一群年轻的边防战士用青春守护着地图上那条最细的线。风雪、孤独与信念交织，讲述属于普通人的英雄故事。',
    releaseDate: '2024-01-19',
    views: 11200000,
    favorites: 175000,
    reviews: [
      { author: '敬礼', rating: 9.2, content: '真实、克制、有力量，看的时候一直起鸡皮疙瘩。' },
      { author: '老班长', rating: 8.6, content: '群像刻画出色，每一个战士都有血有肉。' },
    ],
    featured: true,
    updatedAt: '2024-09-16',
  },
  {
    id: 'wudu-yiyun',
    title: '雾都疑云',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=British%20mystery%20series%20poster%2C%20foggy%20Victorian%20London%20street%20with%20gas%20lamps%2C%20a%20detective%20in%20a%20long%20coat%2C%20muted%20grey%20and%20deep%20green%20tones%2C%20atmospheric%20gothic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-09&orientation=portrait',
    year: 2023,
    region: '英国',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 8.6,
    duration: '全8集',
    director: '萨姆·门德斯',
    actors: ['本尼迪克特·康伯巴奇', '奥利维娅·科尔曼'],
    synopsis: '十九世纪的伦敦，浓雾与罪恶一同蔓延。一位行为古怪却头脑缜密的私家侦探，与一位固执的女记者联手，揭开一连串看似毫无关联的离奇案件。',
    releaseDate: '2023-10-06',
    views: 6320000,
    favorites: 97000,
    reviews: [
      { author: '英剧控', rating: 8.8, content: '服化道和氛围拉满，推理逻辑也很扎实。' },
      { author: '福尔摩斯迷', rating: 8.4, content: '主角的怪癖设定很有趣，每集一个案子节奏快。' },
    ],
    updatedAt: '2024-08-11',
  },
  {
    id: 'shan-nabian-de-jia',
    title: '山那边的家',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%2C%20a%20rural%20village%20house%20among%20terraced%20fields%20at%20golden%20hour%2C%20a%20child%20running%20toward%20home%2C%20earthy%20warm%20tones%2C%20nostalgic%20gentle%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-10&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.1,
    duration: '115分钟',
    director: '李睿珺',
    actors: ['海清', '武仁林'],
    synopsis: '在大山深处，一位母亲用最朴素的方式抚育着两个孩子。当城市的机会向孩子们招手，他们必须在离开与留下之间，重新理解“家”的意义。',
    releaseDate: '2023-08-11',
    views: 4120000,
    favorites: 68000,
    reviews: [
      { author: '土地的儿女', rating: 8.3, content: '非常真实，没有刻意煽情，却让人潸然泪下。' },
      { author: '纪录片爱好者', rating: 8.0, content: '镜头语言质朴，是对乡土最深情的注视。' },
    ],
    updatedAt: '2024-07-03',
  },
  {
    id: 'dushi-yeguiren',
    title: '都市夜归人',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20urban%20romance%20poster%2C%20a%20young%20couple%20on%20a%20city%20rooftop%20at%20night%20with%20a%20glowing%20skyline%20behind%2C%20warm%20amber%20and%20soft%20blue%20city%20lights%2C%20romantic%20cinematic%20bokeh%2C%20no%20text&width=400&height=600&seq=sm-cover-11&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '爱情', '剧情'],
    rating: 7.6,
    duration: '全30集',
    director: '沈严',
    actors: ['白宇', '谭松韵'],
    synopsis: '两个在深夜加班后总会在同一家便利店相遇的都市人，从陌生人成为彼此生活里的光。他们的故事，也是每一个在城市中努力生活的人的故事。',
    releaseDate: '2024-04-12',
    views: 5890000,
    favorites: 82000,
    reviews: [
      { author: '打工魂', rating: 7.8, content: '很有代入感，看着看着就想起了自己加班的夜晚。' },
      { author: '糖分补给', rating: 7.5, content: '日常向爱情，温暖又治愈。' },
    ],
    updatedAt: '2024-09-01',
  },
  {
    id: 'wangzhe-zhiren',
    title: '王者之刃',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20action%20movie%20poster%2C%20a%20warrior%20holding%20a%20glowing%20sword%20on%20a%20battlefield%2C%20dramatic%20storm%20sky%20and%20lightning%2C%20rich%20crimson%20and%20steel%20blue%20palette%2C%20epic%20cinematic%20scale%2C%20no%20text&width=400&height=600&seq=sm-cover-12&orientation=portrait',
    year: 2024,
    region: '美国',
    genres: ['动作', '奇幻', '冒险'],
    rating: 7.8,
    duration: '138分钟',
    director: '扎克·施奈德',
    actors: ['亨利·卡维尔', '安雅·泰勒-乔伊'],
    synopsis: '一个被放逐的年轻战士，为洗清家族的冤屈而踏上寻找传说之刃的旅程。当剑锋出鞘，他必须面对的不只是敌国的大军，还有内心的黑暗。',
    releaseDate: '2024-05-24',
    views: 7120000,
    favorites: 104000,
    reviews: [
      { author: '视效控', rating: 8.0, content: '打斗设计非常华丽，视效水准顶级。' },
      { author: '奇幻迷', rating: 7.6, content: '世界观宏大，可惜剧情略简单。' },
    ],
    updatedAt: '2024-08-20',
  },
  {
    id: 'jijing-xiaozhen',
    title: '寂静小镇',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Horror%20mystery%20series%20poster%2C%20an%20abandoned%20american%20small%20town%20street%20at%20night%20with%20a%20single%20flickering%20light%2C%20eerie%20desaturated%20green%20and%20grey%20palette%2C%20unsettling%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-13&orientation=portrait',
    year: 2022,
    region: '美国',
    genres: ['恐怖', '悬疑', '惊悚'],
    rating: 7.4,
    duration: '全10集',
    director: '迈克·弗拉纳根',
    actors: ['卡拉·古奇诺', '亨利·托马斯'],
    synopsis: '一个安静得有些诡异的小镇，居民们对某件事闭口不谈。当一位外来者搬来后，她逐渐发现，这里的寂静并非平和，而是一种被压抑的恐惧。',
    releaseDate: '2022-10-14',
    views: 4480000,
    favorites: 61000,
    reviews: [
      { author: '恐怖片爱好者', rating: 7.6, content: '靠氛围和心理恐惧取胜，不是廉价吓人。' },
      { author: '夜猫子', rating: 7.2, content: '前几集铺垫稍慢，后面渐入佳境。' },
    ],
    updatedAt: '2024-05-09',
  },
  {
    id: 'haishang-mingyue',
    title: '海上明月',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20romance%20film%20poster%2C%20a%20couple%20standing%20on%20a%20quiet%20seaside%20pier%20under%20a%20full%20moon%2C%20muted%20teal%20sea%20and%20soft%20silver%20moonlight%2C%20dreamy%20poetic%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-14&orientation=portrait',
    year: 2023,
    region: '中国台湾',
    genres: ['爱情', '文艺', '剧情'],
    rating: 8.3,
    duration: '112分钟',
    director: '侯孝贤',
    actors: ['张震', '舒淇'],
    synopsis: '渔港的月光下，一段跨越二十年的感情在重逢中被重新打开。那些没有说出口的话，随着潮水一次次涌回岸边。',
    releaseDate: '2023-06-09',
    views: 3760000,
    favorites: 71000,
    reviews: [
      { author: '文艺青年', rating: 8.6, content: '克制、含蓄、余韵悠长，是东方爱情的极致表达。' },
      { author: '海边散步', rating: 8.1, content: '画面诗意，配乐动人，值得反复品味。' },
    ],
    updatedAt: '2024-06-28',
  },
  {
    id: 'shijian-zhouzhe',
    title: '时间褶皱',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20mystery%20poster%2C%20a%20figure%20standing%20in%20a%20fractured%20mirrored%20corridor%20of%20light%2C%20surreal%20geometric%20distortion%2C%20cool%20violet%20and%20amber%20accents%2C%20abstract%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-15&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=Surreal%20abstract%20time%20distortion%20visual%20with%20light%20streaks%20and%20mirrored%20corridors%2C%20cool%20tones%20with%20warm%20gold%20particles%2C%20mind%20bending%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=sm-back-15&orientation=landscape',
    year: 2025,
    region: '美国',
    genres: ['科幻', '悬疑', '剧情'],
    rating: 8.9,
    duration: '134分钟',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '赞达亚'],
    synopsis: '一位物理学家在一次实验事故后发现，自己的记忆正在不同时间线之间撕裂。为了找回真相，他必须穿越自己人生的每一个褶皱，直面那些被遗忘的选择。',
    releaseDate: '2025-01-10',
    views: 10240000,
    favorites: 214000,
    reviews: [
      { author: '烧脑研究所', rating: 9.1, content: '结构精妙，逻辑自洽，看完还需要复盘好几遍。' },
      { author: '诺兰粉', rating: 8.8, content: '概念宏大又不失情感内核，大师水准。' },
    ],
    featured: true,
    updatedAt: '2024-09-20',
  },
  {
    id: 'jianghu-zaijian',
    title: '江湖再见',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20drama%20poster%2C%20a%20swordsman%20on%20a%20misty%20bamboo%20forest%20path%2C%20flowing%20ink%20painting%20style%2C%20jade%20green%20and%20warm%20amber%20palette%2C%20elegant%20ancient%20chinese%20aesthetic%2C%20no%20text&width=400&height=600&seq=sm-cover-16&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['武侠', '古装', '剧情'],
    rating: 8.0,
    duration: '全36集',
    director: '孔笙',
    actors: ['赵丽颖', '王一博'],
    synopsis: '江湖再大，也有相忘于江湖的一天。一位厌倦了厮杀的剑客，在护送一名少女的旅途中，重新拾起了对侠义与自我的理解。',
    releaseDate: '2023-07-28',
    views: 8450000,
    favorites: 132000,
    reviews: [
      { author: '武侠梦', rating: 8.2, content: '打戏干净利落，意境很美，找回看武侠的初心。' },
      { author: '江湖客', rating: 7.8, content: '文戏稍慢，但主角成长线很完整。' },
    ],
    updatedAt: '2024-07-15',
  },
  {
    id: 'poxiao-xingdong',
    title: '破晓行动',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Espionage%20action%20movie%20poster%2C%20an%20agent%20in%20a%20trench%20coat%20in%20a%20rainy%20european%20city%2C%20dawn%20light%20breaking%20behind%20old%20buildings%2C%20muted%20steel%20blue%20and%20warm%20amber%2C%20tense%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-17&orientation=portrait',
    year: 2024,
    region: '法国',
    genres: ['动作', '谍战', '惊悚'],
    rating: 7.7,
    duration: '124分钟',
    director: '吕克·贝松',
    actors: ['让·雷诺', '蕾雅·赛杜'],
    synopsis: '黎明前的巴黎，一场关乎欧洲能源命脉的秘密交易即将达成。一名老练的特工必须在破晓之前阻止它，而他的每一步都在对手的算计之中。',
    releaseDate: '2024-02-16',
    views: 4910000,
    favorites: 64000,
    reviews: [
      { author: '谍战迷', rating: 7.9, content: '节奏紧凑，反转不断，法式冷峻风格很带感。' },
      { author: '巴黎散步', rating: 7.5, content: '取景很美，动作设计干净利落。' },
    ],
    updatedAt: '2024-06-19',
  },
  {
    id: 'nvyisheng-riji',
    title: '女医生的日记',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Medical%20drama%20series%20poster%2C%20a%20young%20female%20doctor%20in%20a%20white%20coat%20in%20a%20hospital%20corridor%2C%20soft%20clean%20daylight%2C%20calm%20white%20and%20mint%20green%20palette%2C%20hopeful%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-18&orientation=portrait',
    year: 2024,
    region: '日本',
    genres: ['医疗', '剧情', '职场'],
    rating: 8.5,
    duration: '全11集',
    director: '西谷弘',
    actors: ['石原里美', '坂口健太郎'],
    synopsis: '一名在地方医院工作的年轻女医生，用日记记录下每天都在发生的生死与温情。在理想与现实的拉扯中，她逐渐成长为一位真正的医者。',
    releaseDate: '2024-03-01',
    views: 5680000,
    favorites: 88000,
    reviews: [
      { author: '日剧控', rating: 8.7, content: '专业细节扎实，情感表达克制却动人。' },
      { author: '白衣天使', rating: 8.3, content: '很真实地展现了医护的日常与压力。' },
    ],
    updatedAt: '2024-08-27',
  },
  {
    id: 'xueguo-liechezhang',
    title: '雪国列车长',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Disaster%20action%20movie%20poster%2C%20a%20speeding%20train%20crossing%20a%20frozen%20snowy%20landscape%20at%20dusk%2C%20icy%20blue%20and%20warm%20headlight%20glow%2C%20epic%20cold%20cinematic%20scale%2C%20no%20text&width=400&height=600&seq=sm-cover-19&orientation=portrait',
    year: 2022,
    region: '韩国',
    genres: ['灾难', '动作', '剧情'],
    rating: 7.9,
    duration: '129分钟',
    director: '奉俊昊',
    actors: ['宋康昊', '李政宰'],
    synopsis: '一场突如其来的极寒席卷大陆，一列满载幸存者的列车成为人类最后的方舟。而在车厢之间，秩序正在崩塌，人性的光与暗一同被逼到极限。',
    releaseDate: '2022-12-02',
    views: 6180000,
    favorites: 92000,
    reviews: [
      { author: '灾难片迷', rating: 8.1, content: '场面宏大又充满隐喻，娱乐性与深度兼具。' },
      { author: '列车旅客', rating: 7.7, content: '群像戏精彩，封闭空间的张力十足。' },
    ],
    updatedAt: '2024-05-30',
  },
  {
    id: 'guangying-zhicheng',
    title: '光影之城',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20workplace%20drama%20poster%2C%20a%20young%20man%20on%20a%20city%20bridge%20overlooking%20a%20glowing%20metropolis%20at%20blue%20hour%2C%20cool%20cyan%20and%20warm%20amber%20skyline%2C%20aspirational%20cinematic%20mood%2C%20no%20text&width=400&height=600&seq=sm-cover-20&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '职场', '剧情'],
    rating: 8.2,
    duration: '全34集',
    director: '滕华涛',
    actors: ['雷佳音', '殷桃'],
    synopsis: '一座城市，一群人，把青春与野心都押在了这片霓虹之下。当理想照进现实，他们学会在光影交错之间，找到属于自己的位置。',
    releaseDate: '2025-02-20',
    views: 6720000,
    favorites: 95000,
    reviews: [
      { author: '都市观察', rating: 8.4, content: '很接地气的职场群像，台词扎心。' },
      { author: '打工人', rating: 8.0, content: '每个人物都能在身边找到影子。' },
    ],
    updatedAt: '2024-09-22',
  },
];

export const newsList: NewsItem[] = [
  {
    id: 'news-01',
    title: '年度科幻巨制《星海远征》票房突破 30 亿，续作正式立项',
    category: '行业要闻',
    summary: '凭借出色的视效与扎实的剧本，《星海远征》成为本年度现象级作品，片方宣布续作已进入前期筹备阶段。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20news%20editorial%20image%20of%20a%20space%20opera%20film%20premiere%20with%20glowing%20blue%20stage%20lights%20and%20a%20planet%20backdrop%2C%20modern%20clean%20composition%2C%20no%20text&width=800&height=500&seq=sm-news-01&orientation=landscape',
    date: '2026-09-15',
  },
  {
    id: 'news-02',
    title: '悬疑剧集《长夜将明》口碑爆棚，被誉为本年度最佳国产剧',
    category: '新剧推荐',
    summary: '播出仅一周，《长夜将明》便在各大平台收获高分，紧凑的叙事与精湛的表演引发广泛讨论。',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20editorial%20image%20of%20a%20rainy%20city%20at%20night%20with%20neon%20reflections%2C%20deep%20blue%20and%20amber%20tones%2C%20mystery%20drama%20promotional%20atmosphere%2C%20no%20text&width=800&height=500&seq=sm-news-02&orientation=landscape',
    date: '2026-09-22',
  },
  {
    id: 'news-03',
    title: '暑期档盘点：动画与家庭题材成最大赢家',
    category: '市场观察',
    summary: '今年暑期档类型丰富，多部治愈系动画与家庭题材作品逆势上扬，观众对温情的需求愈发明显。',
    cover: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20editorial%20image%20of%20a%20summer%20cinema%20marquee%20with%20warm%20golden%20light%20and%20soft%20pastel%20accents%2C%20festive%20clean%20composition%2C%20no%20text&width=800&height=500&seq=sm-news-03&orientation=landscape',
    date: '2026-08-30',
  },
];

export const regionOptions = ['中国大陆', '美国', '中国香港', '中国台湾', '日本', '韩国', '英国', '法国'];
export const yearOptions = [2025, 2024, 2023, 2022];
export const genreOptions = ['科幻', '剧情', '悬疑', '犯罪', '爱情', '动作', '动画', '古装', '喜剧', '战争', '恐怖', '家庭', '武侠', '都市', '历史', '医疗'];